import React, { ChangeEvent, useState } from 'react';
import Box from '@material-ui/core/Box';
import { useDropzone } from 'react-dropzone';

import Feedbacker from 'components/Feedbacker';
import AddFilesModal from 'components/Modal/AddFilesModal';
import SubmitButton from 'components/Forms/SubmitButton/SubmitButtonComponent';
import FilesList from 'components/FilesList';
import { IEmployeeFile } from 'types/files';

import { MutateFunction } from 'react-query';
import styles from './styles.module.scss';

interface IProps {
  files?: IEmployeeFile[];
  uploadError: string | null;
  uploadFile: MutateFunction<IEmployeeFile, unknown, FormData, unknown>;
  resetUploadError: () => void;
  setLoading: (value: React.SetStateAction<boolean>) => void;
}

const PersonalFiles: React.FC<IProps> = ({
  files,
  uploadError,
  resetUploadError,
  setLoading,
  uploadFile,
}) => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isFileSubmitting, setFileSubmitting] = useState(false);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setSelectedFiles(acceptedFiles);
    },
  });

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedFiles([]);
  };

  const changeSelectedFileName = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const value = e.target.value;
    setSelectedFiles((files) =>
      files.map((file, i) =>
        i === index ? new File([file], value, { type: file.type }) : file
      )
    );
  };

  const saveSelectedFiles = async () => {
    const file = selectedFiles[0]; // For now we are sending only one file. In future it might be multiple
    let formData = new FormData();
    formData.append('filename', file);
    formData.append('title', file.name);
    try {
      setFileSubmitting(true);
      await uploadFile(formData);
    } finally {
      setFileSubmitting(false);
      setSelectedFiles([]);
      setModalOpen(false);
    }
  };

  return (
    <>
      <Box className={styles.addFileBtnContainer}>
        <SubmitButton
          className={styles.btnAdd}
          onClick={() => setModalOpen(true)}
          label="Add file"
        />
      </Box>
      <FilesList files={files} personal setLoading={setLoading} />
      <AddFilesModal
        changeFileName={changeSelectedFileName}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        saveSelectedFiles={saveSelectedFiles}
        handleCloseModal={handleCloseModal}
        isDragActive={isDragActive}
        isDragAccept={isDragAccept}
        isDragReject={isDragReject}
        isOpen={modalOpen}
        isFileSubmitting={isFileSubmitting}
        selectedFiles={selectedFiles}
      />
      <Feedbacker
        open={!!uploadError}
        autoHideDuration={5000}
        displayInTheMiddle={false}
        clearFeedback={() => resetUploadError()}
        severity="error"
        feedbackMessage={uploadError as string}
      />
    </>
  );
};

export default PersonalFiles;
